<template>
	<div class="aspect-wrapper">
		<div class="aspect-wrapper-top">
			<h2>{{ itemsCount }} Results</h2>
			<router-link class="nav-item btn" to="/aspect/add">Add New</router-link>
		</div>
		<div class="aspect-wrapper-sorting">
			<AspectTableSorting
				@on-sorting-change="handleOnSortingChange"
			/>
		</div>
		<div class="aspect-wrapper-table">
			<transition name="fade">
				<AspectTableList
					v-if="!preloaderVisibility"
					:aspects="aspects"
				/>
			</transition>
		</div>
		<div class="aspect-wrapper-navigation">
			<AspectTablePrevButton
				v-if="!preloaderVisibility"
				@on-prev-button-click="onNavigationButtonClick"
				:offset="searchParams.offset"
				:limit="searchParams.limit"
			/>
			<AspectTableNextButton
				v-if="!preloaderVisibility"
				@on-next-button-click="onNavigationButtonClick"
				:offset="searchParams.offset"
				:maxItems="itemsCount"
				:limit="searchParams.limit"
			/>
		</div>
		<PreloaderComponent v-if="preloaderVisibility"/>
	</div>
</template>

<script>
import debounce from 'debounce'

import SolFileAPIInstance from '@/api'

import AspectTableList from '@/components/AspectTable/AspectTableList'
import PreloaderComponent from '@/components/common/PreloaderComponent'
import AspectTableNextButton from '@/components/AspectTable/AspectTableNextButton'
import AspectTablePrevButton from '@/components/AspectTable/AspectTablePrevButton'
import AspectTableSorting from '@/components/AspectTable/AspectTableSorting/AspectTableSorting'

export default {
	name: "AspectTable",
	components: {
		AspectTableList,
		PreloaderComponent,
		AspectTableSorting,
		AspectTableNextButton,
		AspectTablePrevButton
	},
	data() {
		return {
			preloaderVisibility: true,
			itemsCount: 0,
			aspects: [],
			searchParams: {
				offset: 0,
				limit: 10,
				sortingParams: []
			}
		}
	},

	methods: {

		handleOnSortingChange(data) {
			this.preloaderVisibility = true
			this.searchParams.sortingParams = data.map(item => ({
				value: item.currentValue,
				type: item.label
			}))
			this.searchParams.offset = 0
		},

		onNavigationButtonClick(offset) {
			this.preloaderVisibility = true
			this.searchParams.offset = offset
		},

		fetchAspects: debounce(async function () {
			const response = await SolFileAPIInstance.getAspectInterpretations(this.searchParams)
			if (response && response.data) {
        this.aspects = response.data.aspects
        this.itemsCount = response.data.total
			}
			this.preloaderVisibility = false
		}, 700),

	},

	mounted() {
		setTimeout(() => {
			this.fetchAspects()
		}, 1000)
	},

	watch: {
		searchParams: {
			deep: true,
			handler() {
				this.fetchAspects()
			}
		}
	}

}

</script>

<style scoped lang="scss">

.aspect-wrapper {
	padding: 25px;

	&-table {
		margin-top: 20px;
	}

	&-top {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
	}

	&-navigation {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}
}

.fade-enter-active, .fade-leave-active {
	transition: opacity .5s;
}

.fade-enter, .fade-leave-to {
	opacity: 0;
}

</style>